// extracted by mini-css-extract-plugin
export default {"form-card":"Common_form-card__oTT6c","form-title":"Common_form-title__tXWyf","form-desc":"Common_form-desc__b4dyq"};